import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { StickyHeaderNavigation } from '@/components'
import { OpenSumsubSDKButton } from '@/features'
import useOffsets from '@/hooks/useOffsets'

export default function CheckYourIdentity() {
  const { t } = useTranslation()
  const offsets = useOffsets()

  const handlePrivacyPolicyClick = () => {
    window.open('https://kemapp.io/policies/privacy-policy', '_blank')
  }

  return (
    <BaseSafeFormView
      style={{
        paddingTop: offsets.top + 70,
        paddingBottom: offsets.bottom,
      }}
      flex={1}
      bgColor="background.screen"
    >
      <StickyHeaderNavigation />

      <BaseView
        flex={1}
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingLeft: '13px',
          paddingRight: '13px',
        }}
      >
        {/* Main content */}
        <BaseView gap={60} style={{ marginTop: '18px' }}>
          {/* Title and description */}
          <BaseView gap={12}>
            <BaseText fontSize={24} fontFamily="bold" color="label.default">
              {t('translation:verifyIdentity')}
            </BaseText>
            <BaseText fontSize={16} color="label.secondary">
              {t('translation:completeVerificationIdentity')}
            </BaseText>
          </BaseView>

          {/* Image */}
          <BaseView center>
            <img
              src="/assets/images/facial-biometrics-scan.png"
              alt="Facial biometrics scan"
              style={{
                width: '100%',
                maxWidth: '320px',
                height: '240px',
                objectFit: 'contain',
              }}
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.src = '/assets/images/kem-desert.png'
              }}
            />
          </BaseView>
        </BaseView>

        {/* Footer */}
        <BaseView
          gap={42}
          style={{
            marginTop: 'auto',
            paddingBottom: '12px',
          }}
        >
          {/* Privacy policy text */}
          <BaseView style={{ paddingHorizontal: '28px' }}>
            <BaseText
              fontSize={14}
              color="label.secondary"
              textAlign="center"
              style={{ lineHeight: '20px' }}
            >
              {t('translation:acceptShareFacialBiometrics')}
              {'\n'}
              <BaseText
                fontSize={14}
                color="label.clickable"
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={handlePrivacyPolicyClick}
              >
                {t('translation:followingPrivacyAndPolicies')}
              </BaseText>
            </BaseText>
          </BaseView>

          {/* Continue Button */}
          <OpenSumsubSDKButton />
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
